import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';
const Footer = () => {
    return (
        <>
        <footer className="footer"><p>Copyright © 2020 Journary. All rights reserved | Developed with <FontAwesomeIcon
              className=""
              icon="heart"
              size="1x"
            /> by <a href="https://twitter.com/kingdayvidz">Temitope.js</a></p></footer>
        </>
    )
}
export default Footer